import "./main.css";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $ea2e8e3460b67692$exports = {};
$parcel$export($ea2e8e3460b67692$exports, "spectrum--darkest", function () {
  return $ea2e8e3460b67692$export$4ecdba604f5f1f44;
}, function (v) {
  return $ea2e8e3460b67692$export$4ecdba604f5f1f44 = v;
});
var $ea2e8e3460b67692$export$4ecdba604f5f1f44;
$ea2e8e3460b67692$export$4ecdba604f5f1f44 = "spectrum--darkest_256eeb";
var $5b6ea5874ed9af7b$exports = {};
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum", function () {
  return $5b6ea5874ed9af7b$export$3311ab3a441bc141;
}, function (v) {
  return $5b6ea5874ed9af7b$export$3311ab3a441bc141 = v;
});
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--medium", function () {
  return $5b6ea5874ed9af7b$export$4c0c83b3f4303ef8;
}, function (v) {
  return $5b6ea5874ed9af7b$export$4c0c83b3f4303ef8 = v;
});
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--large", function () {
  return $5b6ea5874ed9af7b$export$a88a8dbe29386d31;
}, function (v) {
  return $5b6ea5874ed9af7b$export$a88a8dbe29386d31 = v;
});
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--darkest", function () {
  return $5b6ea5874ed9af7b$export$4ecdba604f5f1f44;
}, function (v) {
  return $5b6ea5874ed9af7b$export$4ecdba604f5f1f44 = v;
});
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--dark", function () {
  return $5b6ea5874ed9af7b$export$68dc111a79481afd;
}, function (v) {
  return $5b6ea5874ed9af7b$export$68dc111a79481afd = v;
});
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--light", function () {
  return $5b6ea5874ed9af7b$export$efb37c2f79da8163;
}, function (v) {
  return $5b6ea5874ed9af7b$export$efb37c2f79da8163 = v;
});
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--lightest", function () {
  return $5b6ea5874ed9af7b$export$baaa804dc80cce18;
}, function (v) {
  return $5b6ea5874ed9af7b$export$baaa804dc80cce18 = v;
});
var $5b6ea5874ed9af7b$export$3311ab3a441bc141;
var $5b6ea5874ed9af7b$export$4c0c83b3f4303ef8;
var $5b6ea5874ed9af7b$export$a88a8dbe29386d31;
var $5b6ea5874ed9af7b$export$4ecdba604f5f1f44;
var $5b6ea5874ed9af7b$export$68dc111a79481afd;
var $5b6ea5874ed9af7b$export$efb37c2f79da8163;
var $5b6ea5874ed9af7b$export$baaa804dc80cce18;
$5b6ea5874ed9af7b$export$3311ab3a441bc141 = "spectrum_9e130c";
$5b6ea5874ed9af7b$export$4c0c83b3f4303ef8 = "spectrum--medium_9e130c";
$5b6ea5874ed9af7b$export$a88a8dbe29386d31 = "spectrum--large_9e130c";
$5b6ea5874ed9af7b$export$4ecdba604f5f1f44 = "spectrum--darkest_9e130c";
$5b6ea5874ed9af7b$export$68dc111a79481afd = "spectrum--dark_9e130c";
$5b6ea5874ed9af7b$export$efb37c2f79da8163 = "spectrum--light_9e130c";
$5b6ea5874ed9af7b$export$baaa804dc80cce18 = "spectrum--lightest_9e130c";
var $b2eefcc3e5fdb373$exports = {};
$parcel$export($b2eefcc3e5fdb373$exports, "spectrum--large", function () {
  return $b2eefcc3e5fdb373$export$a88a8dbe29386d31;
}, function (v) {
  return $b2eefcc3e5fdb373$export$a88a8dbe29386d31 = v;
});
var $b2eefcc3e5fdb373$export$a88a8dbe29386d31;
$b2eefcc3e5fdb373$export$a88a8dbe29386d31 = "spectrum--large_c40598";
var $729ae839c55d8d77$exports = {};
$parcel$export($729ae839c55d8d77$exports, "spectrum--light", function () {
  return $729ae839c55d8d77$export$efb37c2f79da8163;
}, function (v) {
  return $729ae839c55d8d77$export$efb37c2f79da8163 = v;
});
var $729ae839c55d8d77$export$efb37c2f79da8163;
$729ae839c55d8d77$export$efb37c2f79da8163 = "spectrum--light_a40724";
var $b4d117254fac085c$exports = {};
$parcel$export($b4d117254fac085c$exports, "spectrum--medium", function () {
  return $b4d117254fac085c$export$4c0c83b3f4303ef8;
}, function (v) {
  return $b4d117254fac085c$export$4c0c83b3f4303ef8 = v;
});
var $b4d117254fac085c$export$4c0c83b3f4303ef8;
$b4d117254fac085c$export$4c0c83b3f4303ef8 = "spectrum--medium_4b172c";
var $bf24a13e98395dd3$export$bca14c5b3b88a9c9 = {
  global: /*@__PURE__*/$parcel$interopDefault($5b6ea5874ed9af7b$exports),
  light: /*@__PURE__*/$parcel$interopDefault($729ae839c55d8d77$exports),
  dark: /*@__PURE__*/$parcel$interopDefault($ea2e8e3460b67692$exports),
  medium: /*@__PURE__*/$parcel$interopDefault($b4d117254fac085c$exports),
  large: /*@__PURE__*/$parcel$interopDefault($b2eefcc3e5fdb373$exports)
};
export { $bf24a13e98395dd3$export$bca14c5b3b88a9c9 as theme };